import React, { Component } from "react";
import "./modal.css";
import crossIcon from '../../images/Icon-Cross.svg';
const CustomModal = (props) => {
  const {
    className,
    onClose,
    size,
    modalTitle,
    closeIcon = true,
    modalFooter,
    children,
    titleClass = "modal-title_custom",
    bodyStyle = {},
  } = props;
  if (!props.show) {
    return null;
  }
  return (
    <div className={className}>
      <div className="modal_custom" id="customModal" onClick={onClose}>
        <div
          className={` ${className}  modal-content_custom`}
          onClick={(e) => e.stopPropagation()}
          style={{ width: size }}
        >
          {modalTitle && (
            <div className="modal-header_custom">
              <h4 className={titleClass}>
                {modalTitle}
                {closeIcon && (
                  <span
                    onClick={onClose}
                    style={{
                      color: "black",
                      "font-size": "20px",
                      float: "right",
                      cursor: "default",
                    }}
                  >
                   <img src={crossIcon} alt="cross-icon"/>
                  </span>
                )}
              </h4>
            </div>
          )}
          <div className="modal-body_custom" style={bodyStyle ? bodyStyle : {}}>
            {children}
          </div>
          {modalFooter && (
            <div className="modal-footer_custom">{modalFooter}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;

